// mixins/loading.js
export default {
  data() {
    return {
      loadingInstance: null
    }
  },
  methods: {
    mixins_loadingStart(info = null) {
      // 如果已有loading，先关闭
      this.mixins_loadingClose()
      this.loadingInstance = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      })
    },
    mixins_loadingClose() {
      if (this.loadingInstance) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    }
  },
  // 组件销毁时自动关闭loading
  beforeDestroy() {
    this.mixins_loadingClose()
  }
}


// WEBPACK FOOTER //
// ./mixins/loading.js